import React, { useMemo } from 'react'
import classNames from 'classnames'

import type { LinkType } from 'types'
import { formatDate } from 'ui-component-library/utils/helpers'
import CommentToggleButton from '../CommentToggleButton'
import HeadlineOne from '../00-Primitives/Headlines/HeadlineOne'
import Link from 'content-components/_Primatives/Link'
import Ruler from '../00-Primitives/Ruler'
import SocialSharingInline from '../SocialSharing/SocialSharingInline'
import style from './style.scss'

type Props = {
  authorName: string
  baseUrl: string
  bylineText: string
  categories?: Array<string>
  categoryLinks?: LinkType[]
  categoryLinksLabelText?: string
  cfdailyLinks?: LinkType[]
  className?: string
  commentLabelText: string
  commentsCount?: number
  commentsUrl: string
  date: string
  headlineText: string
  mailLabelText: string
  navLabelText: string
  twitterLabelText: string
}

function ArticleHeader(props: Props) {
  const {
    authorName,
    bylineText,
    categories,
    categoryLinks = [],
    categoryLinksLabelText,
    cfdailyLinks = [],
    className,
    date,
    headlineText,
    mailLabelText,
    navLabelText,
    twitterLabelText,
    commentLabelText,
    commentsCount,
    commentsUrl,
  } = props

  const formattedDate = useMemo(() => formatDate(date, 'MMMM d, yyyy'), [date])
  const classes = categories
    ? categories.map((category) => style[category]).filter(Boolean)
    : ''

  const foundInLinks = [...cfdailyLinks, ...categoryLinks]

  return (
    <header className={classNames(style.wrapper, className, classes)}>
      <Ruler className={style.contentSpacing} />
      <div className={style.headlineComments}>
        <HeadlineOne className={style.headline}>{headlineText}</HeadlineOne>
        <CommentToggleButton
          topicText={headlineText}
          labelText={commentLabelText}
          count={commentsCount}
          url={commentsUrl}
        />
      </div>
      <div className={style.publishedDetails}>
        {bylineText}
        <span className={style.authorName}>{authorName}</span>
        <span className={style.featuredDailyLink}>{formattedDate}</span>
      </div>
      {foundInLinks.length > 0 && (
        <div className={style.categoryDetails}>
          <span>{categoryLinksLabelText}:</span>
          {foundInLinks.map(({ text, url }, index, array) => (
            <span key={text}>
              <Link
                className={classNames(style.link, style.categoryLink)}
                url={url}
              >
                {text}
              </Link>
              {array.length - 1 !== index && ','}
            </span>
          ))}
        </div>
      )}
      <SocialSharingInline
        mailLabelText={mailLabelText}
        navLabelText={navLabelText}
        title={headlineText}
        twitterLabelText={twitterLabelText}
      />
    </header>
  )
}

export default ArticleHeader
